import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  IconButton,
  Input,
  useToast,
  Image,
  Flex,
  Switch,
  TableContainer,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { AddIcon, EditIcon, MinusIcon } from "@chakra-ui/icons";
import { appRequest } from "routes";
import { FaSave, FaTimes } from "react-icons/fa";
import { useHasPermission } from "App/DMRC/components/common/PermissionsFunction/permissiosnFunction";

interface Provider {
  providerName: string;
  prefrence: number;
  metroImg: string;
  is_active: boolean;
}

type props = {
  cityId: string;
  CityCode: string;
};

export default function ProviderPref({ cityId, CityCode }: props) {
  const [providers, setProviders] = useState<Provider[]>([]);
  const [editedProviders, setEditedProviders] = useState<{
    [key: string]: number;
  }>({});
  const [switchStates, setSwitchStates] = useState<boolean[]>([]);
  const toast = useToast();

  // Fetch providers
  const getProviders = async () => {
    try {
      //  const id = "670e3fa30afc7035c8fecaba";
      const id = cityId;
      const cityCode = CityCode;
      const response: any = await appRequest("metro", "allProviders", { id, cityCode });

      if (response.status === "success") {
        setProviders(response.allProviders || []);
        console.log("response.allProviders", response.allProviders)
        initializeSwitchStates(response?.allProviders);
      }
    } catch (error: any) {
      console.error("Error fetching providers:", error);
      toast({
        title: "Error",
        description: "Failed to fetch providers.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const initializeSwitchStates = (lines: any[]) => {
    const initialStates = lines.map((line) =>
      line?.disabled === null ? true : !line?.disabled
    );
    setSwitchStates(initialStates);
    console.log("initial states ", initialStates);
  };

  // Save the updated preference
  const savePreference = async (providerName: string) => {
    try {
      // const id = "670e3fa30afc7035c8fecaba";
      const id = cityId;

      const payload = {
        id,
        cityCode: CityCode,
        providerName,
        prefrence: editedProviders[providerName],
      };

      const response: any = await appRequest(
        "metro",
        "updateProviderPrefrence",
        payload
      );
      if (response.status === "success") {
        toast({
          title: "Success",
          description: "Preference updated successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });

        setProviders((prev) =>
          prev.map((provider) =>
            provider.providerName === providerName
              ? { ...provider, prefrence: payload.prefrence }
              : provider
          )
        );
        cancelEdit(providerName);
      }
    } catch (error: any) {
      console.error("Error updating preference:", error);
      toast({
        title: "Error",
        description: "Failed to update preference.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleSwitchChange = (name: string, value: any) => {
    setSwitchStates((prevSwitchStates: any) =>
      prevSwitchStates.map((switchState: any) =>
        switchState.name === name
          ? { ...switchState, isActive: value }
          : switchState
      )
    );
    handleSingleState(name, value);
  };

  //Change switch state of provider
  const handleSingleState = async (name: any, value: any) => {
    try {
      const payload = {
        id: cityId,
        cityCode: CityCode,
        providerName: name,
        is_active: value,
      };
      const result: any = await appRequest(
        "metro",
        "updateProviderStatus",
        payload
      );

      if (result.status === "success") {
        toast({
          title: "Success",
          description: "Provider Status updated successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
        await getProviders();
      }
    } catch (error: any) {
      toast({
        title: "Error",
        description: "Failed to update Provider status.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
      console.error(error.message);
    }
  };

  //handle cron for providers
  const handelcron = async () => {
    let loadingToast: any;
    try {
      loadingToast = toast({
        title: "Processing",
        description: "Adding cron to providers, please wait...",
        status: "loading",
        duration: null,
        isClosable: true,
        position: "top",
      });
      const cityCode = CityCode;
      const mapId = cityId;

      const payload = {
        cityCode,
        mapId
      };

      const response: any = await appRequest(
        "metro",
        "cronToAddProviders",
        payload
      );
      toast.close(loadingToast);
      if (response.status === "success") {
        toast({
          title: "Success",
          description: " added cron to providers successfully!",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
        getProviders();
        toast({
          title: "Info",
          description: "Please update preference for providers",
          status: "info",
          duration: 8000,
          isClosable: true,
          position: "top",
        });
      }
    } catch (error: any) {
      toast.close(loadingToast);
      console.error("Error adding cron to providers:", error);
      toast({
        title: "Error",
        description: "Failed to add cron to providers.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Cancel editing
  const cancelEdit = (providerName: string) => {
    setEditedProviders((prev) => {
      const updated = { ...prev };
      delete updated[providerName];
      return updated;
    });
  };

  useEffect(() => {
    getProviders();
  }, []);

  const canEditProviders = useHasPermission("canEditProviders");
  return (
    <>
      <Box
        p={{ base: 5, md: 5 }}
        rounded={"lg"}
        bg={"white"}
        shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
      >
        <Flex justify={"end"} gap={2} mb={2}>
          <Button
            onClick={() => {
              handelcron();
            }}
            colorScheme="teal"
            aria-label="add cron"
          >
            Add Provider Cron
          </Button>
        </Flex>
        <TableContainer className="customScrollBar" pb={2}>
          <Table variant="striped">
            <Thead>
              <Tr>
                <Th></Th>
                <Th>Provider Name</Th>
                <Th>Preference</Th>
                <Th>State</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {providers.map((provider, index: number) => (
                <Tr key={provider?.providerName}>
                  <Td>
                    <Image
                      src={provider?.metroImg}
                      alt={provider?.providerName}
                      w={"50px"}
                      h={"50px"}
                      objectFit={"contain"}
                    />
                  </Td>
                  <Td>{provider.providerName}</Td>
                  <Td>
                    {editedProviders[provider?.providerName] !== undefined ? (
                      <Box display="flex" alignItems="center" gap="2">
                        <IconButton
                          size="sm"
                          aria-label="Decrement"
                          isDisabled={
                            editedProviders[provider?.prefrence] === 1
                          }
                          icon={<MinusIcon />}
                          onClick={() =>
                            setEditedProviders((prev) => ({
                              ...prev,
                              [provider?.providerName]:
                                (prev[provider?.providerName] || 0) - 1,
                            }))
                          }
                        />
                        <Input
                          size="sm"
                          width="50px"
                          textAlign={"center"}
                          min={1}
                          value={editedProviders[provider?.providerName]}
                          readOnly
                        />
                        <IconButton
                          size="sm"
                          aria-label="Increment"
                          icon={<AddIcon />}
                          onClick={() =>
                            setEditedProviders((prev) => ({
                              ...prev,
                              [provider?.providerName]:
                                (prev[provider?.providerName] || 0) + 1,
                            }))
                          }
                        />
                      </Box>
                    ) : (
                      provider?.prefrence
                    )}
                  </Td>
                  <Td>
                    <Switch
                      size="md"
                      colorScheme="teal"
                      isChecked={provider.is_active}
                      onChange={(e) => {
                        handleSwitchChange(
                          provider.providerName,
                          e.target.checked
                        );
                      }}
                    />
                  </Td>
                  <Td>
                    {editedProviders[provider?.providerName] !== undefined ? (
                      <Flex gap="2">
                        <IconButton
                          aria-label="Save"
                          icon={<FaSave />}
                          colorScheme="teal"
                          size="sm"
                          variant={"outline"}
                          mr={2}
                          onClick={() => savePreference(provider?.providerName)}
                        />
                        <IconButton
                          aria-label="Cancel"
                          icon={<FaTimes />}
                          colorScheme="red"
                          size="sm"
                          variant={"outline"}
                          onClick={() => cancelEdit(provider?.providerName)}
                        />
                      </Flex>
                    ) : (
                      <>
                        {canEditProviders && (
                          <IconButton
                            aria-label="edit"
                            variant={"outline"}
                            colorScheme="teal"
                            icon={<EditIcon />}
                            size="sm"
                            onClick={() =>
                              setEditedProviders((prev) => ({
                                ...prev,
                                [provider?.providerName]: provider?.prefrence,
                              }))
                            }
                          />
                        )}
                      </>
                    )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}
